module.exports = __webpack_public_path__ + "static/media/content-hub.f797b0ee.jpg";